import { isDefined } from '@sgme/fp';
import classNames from 'classnames';
import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedNumber } from 'components/shared/Intl';
import { NumberValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';

export interface ProductSummaryNumberFieldProps {
  node: NumberValueDefinition;
}

export const ProductSummaryNumberField: FC<ProductSummaryNumberFieldProps> = ({ node }) => {
  const data = useReadonlyField().getMetadataWithData(node);

  const translationKey = node.translationKey ?? node.id;
  const isHighlighted = node.isHighlighted ?? false;

  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      <p
        className={classNames('text-large m-0', {
          'fw-light': !isHighlighted,
          'fw-bold': isHighlighted,
          'text-danger': isHighlighted,
        })}
        data-e2e={`product-summary-field-${node.id}`}
      >
        {isDefined(data) && <FormattedNumber maximumFractionDigits={4} value={data} />}
      </p>
    </SummaryFieldRow>
  );
};

ProductSummaryNumberField.displayName = 'ProductSummaryNumberField';
